/**
 * @desc 通过SupplierIdName获取供应商交易主体信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/getInfoBySupplierIdName`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
